import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Output, NgModule } from '@angular/core';
import { PrimengLibraryModule } from 'primeng-library';

class CreateTaskActionsService {
    constructor() { }
}
CreateTaskActionsService.ɵfac = function CreateTaskActionsService_Factory(t) { return new (t || CreateTaskActionsService)(); };
CreateTaskActionsService.ɵprov = i0.ɵɵdefineInjectable({ token: CreateTaskActionsService, factory: CreateTaskActionsService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CreateTaskActionsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class CreateTaskActionsComponent {
    constructor() {
        this.createTaskEvent = new EventEmitter();
        this.cancelEvent = new EventEmitter();
    }
    handleCreateTask() {
        this.createTaskEvent.emit('createTask');
    }
    handleCancel() {
        this.cancelEvent.emit('cancelTask');
    }
}
CreateTaskActionsComponent.ɵfac = function CreateTaskActionsComponent_Factory(t) { return new (t || CreateTaskActionsComponent)(); };
CreateTaskActionsComponent.ɵcmp = i0.ɵɵdefineComponent({ type: CreateTaskActionsComponent, selectors: [["create-task-actions-library"]], outputs: { createTaskEvent: "createTaskEvent", cancelEvent: "cancelEvent" }, decls: 7, vars: 0, consts: [[1, "row", "col-12", "mt-4", "mb-2"], [1, "col-3"], ["type", "submit", 1, "btn", "vdCreateBtn", "mr-3", 3, "click"], ["type", "button", 1, "btn", "vdCancelBtn", "mr-3", 3, "click"]], template: function CreateTaskActionsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "button", 2);
        i0.ɵɵlistener("click", function CreateTaskActionsComponent_Template_button_click_2_listener() { return ctx.handleCreateTask(); });
        i0.ɵɵtext(3, "CREATE TASK");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 1);
        i0.ɵɵelementStart(5, "button", 3);
        i0.ɵɵlistener("click", function CreateTaskActionsComponent_Template_button_click_5_listener() { return ctx.handleCancel(); });
        i0.ɵɵtext(6, "CANCEL");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } }, styles: [".btn.vdCreateBtn[_ngcontent-%COMP%]{color:#fff;background-color:#1aa0da}.btn.vdCancelBtn[_ngcontent-%COMP%], .btn.vdCreateBtn[_ngcontent-%COMP%]{border-radius:3px!important;font-weight:100!important}.btn.vdCancelBtn[_ngcontent-%COMP%]{color:#596f88;background-color:#e1e1e1}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CreateTaskActionsComponent, [{
        type: Component,
        args: [{
                selector: 'create-task-actions-library',
                templateUrl: 'create-task-actions.component.html',
                styleUrls: ['create-task-actions.component.scss']
            }]
    }], function () { return []; }, { createTaskEvent: [{
            type: Output
        }], cancelEvent: [{
            type: Output
        }] }); })();

class CreateTaskActionsModule {
}
CreateTaskActionsModule.ɵfac = function CreateTaskActionsModule_Factory(t) { return new (t || CreateTaskActionsModule)(); };
CreateTaskActionsModule.ɵmod = i0.ɵɵdefineNgModule({ type: CreateTaskActionsModule });
CreateTaskActionsModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(CreateTaskActionsModule, { declarations: [CreateTaskActionsComponent], imports: [PrimengLibraryModule], exports: [CreateTaskActionsComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CreateTaskActionsModule, [{
        type: NgModule,
        args: [{
                declarations: [CreateTaskActionsComponent],
                imports: [
                    PrimengLibraryModule
                ],
                exports: [CreateTaskActionsComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of create-task-actions
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CreateTaskActionsComponent, CreateTaskActionsModule, CreateTaskActionsService };
//# sourceMappingURL=create-task-actions.js.map
